import { useFindProfile } from '@hooks/profile'
import { IGenericTask } from '@interfaces/task/generic/IGenericTask'
import { api } from '@services/apiClient'

interface IPutTaskParams {
  id: number
  task: IGenericTask
}

export const usePutTask = () => {
  const { data: user } = useFindProfile()

  const siteId = user && user.selectedSite.id

  const putTask = async ({ id, task }: IPutTaskParams) => {
    const url = `/sites/${siteId}/tasks/${id}`

    const { data } = await api.put<IGenericTask>(url, task)

    return data
  }

  return { putTask }
}
